<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  created() {
    this.$store.dispatch('initializeUser');
  },
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  font-synthesis: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-text-size-adjust: 100%;
}

body {
  height: 100vh;
}

.main {
  display: grid;
  overflow: auto;
  grid-template-areas:
    'header header'
    'aside aside'
    'main main';
  grid-template-rows: 100px 1fr;
  grid-template-columns: 200px 1fr;
  background-color: #e5e5e5;
  height: 100vh;
}

.head {
  grid-area: header;
}

.sidebar {
  grid-area: aside;
}

.dash {
  grid-area: main;
}

@media (min-width: 720px) {
  .main {
    grid-template-areas:
      'header header'
      'aside main';
  }
}

.scrollable-area {
  overflow-y: scroll;
}

.scrollable-area::-webkit-scrollbar {
  width: 5px; /* width of the entire scrollbar */
}

.scrollable-area::-webkit-scrollbar-track {
  background: #d4d4d4; /* color of the tracking area */
}

.scrollable-area::-webkit-scrollbar-thumb {
  background: #2c2c2c; /* color of the scroll thumb */
  border-radius: 4px; /* roundness of the scroll thumb */
}

.message-no-clients-filtered {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-size: 18px;
  font-weight: 400;
  line-height: 20px;
  color: #2c2c2c;
  text-align: center;

  background-color: #d9d9d9;
  padding: 20px;
  margin-top: 20px;
  border-radius: 5px;
}
</style>
